import type {
	UseQueryOptions,
	UseMutationOptions,
	QueryKey,
	QueryFunction,
} from "@tanstack/react-query";
import { useQuery, useMutation } from "@tanstack/react-query";
import type { AxiosError, AxiosResponse } from "axios";

import type { ErrorResponse } from "@schemas/common";

// 타입 정의 추가
export type QueryOpts<TData, TError = AxiosError<ErrorResponse>> = Omit<
	UseQueryOptions<AxiosResponse<TData>, TError, AxiosResponse<TData>, QueryKey>,
	"queryKey" | "queryFn"
>;

export type MutationOpts<
	TData,
	TVariables,
	TError = AxiosError<ErrorResponse>,
> = UseMutationOptions<AxiosResponse<TData>, TError, TVariables>;

export function useCreateQuery<TData, TError = AxiosError<ErrorResponse>>(
	queryKey: QueryKey,
	queryFn: QueryFunction<AxiosResponse<TData>, QueryKey>,
	options?: QueryOpts<TData, TError>,
) {
	return useQuery<AxiosResponse<TData>, TError, AxiosResponse<TData>, QueryKey>({
		queryKey,
		queryFn,
		...options,
	});
}

export function useCreateMutation<TData, TVariables, TError = AxiosError<ErrorResponse>>(
	mutationFn: (variables: TVariables) => Promise<AxiosResponse<TData>>,
	options?: MutationOpts<TData, TVariables, TError>,
) {
	return useMutation<AxiosResponse<TData>, TError, TVariables>({
		mutationFn,
		...options,
	});
}
